export default {
      id: "fullscreen-usage",
      viewBox: "0 0 490.667 490.667",
      url: "/assets/svg/" + "sprite.svg#fullscreen-usage",
      toString: function () {
        return this.url;
      }
    }